// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"ea5cdafd","232":"41a6db35","237":"848916f5","357":"a80aaf25","526":"3b0ad1ac","787":"7da95b79","872":"bb0ac4f4"}[chunkId] + ".chunk.js";
};